import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { FaLock, FaUser } from 'react-icons/fa';
import {
	Form, Input, Button
} from 'antd';
import { ErrorAlert } from '../ErrorAlert';

export const LoginForm = ({ activateAuth }) => {

	const [error, setError] = useState(null);
	const [form] = Form.useForm();
	const [isLoading, setLoading] = useState(false);

	const onSubmit = (values) => {
		setError(null);
		setLoading(true);

		const loginUrl = `${process.env.REACT_APP_BACKEND}/auth/login`;
		axios.post(loginUrl, Object.assign({}, values, { fromReq: 'web' }))
		.then(resp => {
			setLoading(false);
			const { data: { success, token, message } } = resp;
			if (success) {
				activateAuth(token);
			} else {
				setError(message);
			}
		})
		.catch(err => {
			setLoading(false);
			const message = err && err.response && err.response.data && err.response.data.message
				? err.response.data.message
				: 'Unable to connect to ALEX. Please try again.';
			setError(message);
		});
	};

	const onSubmitFailed = ({ errorFields }) => {
		form.scrollToField(errorFields[0].name);
	};

	return (
		<Fragment>
			<Form
				className="alex-login-form"
				form={form}
				onFinish={onSubmit} 
				onFinishFailed={onSubmitFailed}
				layout="vertical"
			>
				<Form.Item
					label="Username"
					name="username"
					rules={[{ required: true, message: 'Username is required' }]}
				>
					<Input
						prefix={<FaUser className="alex-login-input-icon" />}
						placeholder="Enter username"
						autoComplete="username"
					/>
				</Form.Item>
				<Form.Item
					label="Password"
					name="password"
					rules={[{ required: true, message: 'Password is required' }]}
				>
					<Input.Password
						prefix={<FaLock className="alex-login-input-icon" />}
						placeholder="Enter password"
						autoComplete="current-password"
					/>
				</Form.Item>
				<Button 
					className="alex-login-submit" 
					type="primary"
					htmlType="submit"
					loading={isLoading}
				>
					Login
				</Button>
			</Form>
			{
				error && (
					<div className="alex-login-error">
						<ErrorAlert errorMessage={error} />
					</div>
				)
			}
		</Fragment>
	);
};

LoginForm.propTypes = {
	activateAuth: PropTypes.func.isRequired,
};

export default LoginForm;
